var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"posterArea",attrs:{"src":_vm.imageUrl},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }